import { joinClassName } from "./utils/cssUtils";

const systemBaseClassPartial = "oc";

const layoutClassPartial = "l";

const gridClassPartial = "contentGrid";

export const baseClassName = joinClassName(
    systemBaseClassPartial,
    layoutClassPartial,
    gridClassPartial
);

const wrapperClassPartial = "contentWrapper";

export const wrapperClassName = joinClassName(
    baseClassName,
    wrapperClassPartial
);
